import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.onClick = this.onClick.bind(this);
    this.element.addEventListener("click", this.onClick, true);
  }

  disconnect() {
    this.element.removeEventListener("click", this.onClick, true);
  }

  onClick(event) {
    const wrapper = event.target.closest(".bp-video-blob-wrapper");
    if (!wrapper) return;

    const link = wrapper.closest("a");
    if (!link) return;

    let videoUrl = link.dataset.videoUrl;
    if (!videoUrl) {
      const attachment = link.closest("action-text-attachment");
      if (attachment) videoUrl = attachment.getAttribute("url");
    }
    if (!videoUrl) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const poster = link.querySelector(".bp-video-poster, img");
    const posterSrc = poster ? poster.getAttribute("src") : null;
    const posterWidth = poster ? parseInt(poster.getAttribute("width"), 10) : NaN;
    const posterHeight = poster ? parseInt(poster.getAttribute("height"), 10) : NaN;

    const video = document.createElement("video");
    video.src = videoUrl;
    video.controls = true;
    video.autoplay = true;
    video.playsInline = true;
    video.className = "bp-video-player";
    if (posterSrc) video.poster = posterSrc;
    if (Number.isFinite(posterWidth)) video.setAttribute("width", String(posterWidth));
    if (Number.isFinite(posterHeight)) video.setAttribute("height", String(posterHeight));

    const figure = link.closest("figure.attachment");
    const playerWrapper = document.createElement("div");
    playerWrapper.className = "bp-video-blob-wrapper";
    playerWrapper.appendChild(video);

    if (figure) {
      const caption = figure.querySelector("figcaption.attachment__caption");
      figure.replaceChildren(playerWrapper);
      if (caption) figure.appendChild(caption);
    } else {
      link.replaceWith(playerWrapper);
    }

    if (typeof window.onmount === "function") {
      window.onmount();
    }

    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(() => {});
    }
  }
}
